<template>
  <b-container>
    <b-row class="justify-content-md-center">
      <div class="card" style="max-width: 70rem;">
        <div class="card-header card-header-flex" style="width: 100%; overflow-x: auto; overflow-y: hidden;">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <h5 class="mb-0 mr-4" style="min-width: max-content;">Gestión de CMS</h5>
          </div>
          <a-tabs v-model="tabActive" :activeKey="tabActive" class="kit-tabs-bold" @change="changeTab">
            <a-tab-pane tab="Lista" :key="1" />
            <a-tab-pane :tab="isEditing.value ? 'Editar' : 'Crear'" :key="2" />
          </a-tabs>
        </div>
        <div v-if="tabActive == 1">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <h5 class="mb-2"><b>Lista de posts</b></h5>
            <cmsList @editing="recieveEditState" />
          </div>
        </div>
        <div v-if="tabActive == 2">
          <div style="width: 70rem;"></div>
          <div class="card-body">
            <h5 class="mb-2"><b>{{ isEditing.value ? 'Editar Post' : 'Crear Post' }}</b></h5>
            <cmsCreate @finished="finished" :isEditing="this.isEditing"/>
          </div>
        </div>
      </div>
    </b-row>
  </b-container>
</template>

<script>

import { mapState } from 'vuex'
import cmsList from '@/components/custom/cmsList'
import cmsCreate from '@/components/custom/cmsCreate'

export default {
  components: {
    cmsList,
    cmsCreate,
    // emptyTable,
  },
  name: 'cmsManagement',
  data() {
    return {
      isEditing: {
        id: '',
        value: false,
      },
      tabActive: 1,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    changeTab(key) {
      this.tabActive = key
    },
    finished() {
      this.tabActive = 1
      this.isEditing.value = false
    },
    recieveEditState(isEditing) {
      this.isEditing = isEditing
      this.tabActive = 2
    },
  },
}
</script>
<style lang="scss">
@import "./style.module.scss";
</style>
